@if (status && documentStatusMeta[status]) {
  <span class="clinical-onboarding-document-status-badge" [style.color]="documentStatusMeta[status].color" [style.borderColor]="documentStatusMeta[status].color">
    {{ documentStatusMeta[status].i18nKey | translate }}
  </span>
}
